// Per-route SEO metadata.
//
// Every route shares a single index.html, so without this each page would
// inherit the same <title> and description and compete with itself in search
// results. The <Seo /> component applies these on navigation.
//
// `title` is used verbatim as the document title, so include the school name.
// Keep titles under ~60 characters and descriptions under ~155 — beyond that
// search engines truncate them in the results listing.

export const SITE_URL = 'https://macgillisglobalacademy.net';

export const SITE_NAME = 'MacGillis Global Academy';

export const DEFAULT_SEO = {
    title: 'MacGillis Global Academy | Accredited Online School',
    description:
        'MacGillis Global Academy is an accredited independent online school offering live instruction in small classes of 10-16 students, from Lower School through Upper School.'
};

const seoByPath = {
    '/': DEFAULT_SEO,
    '/about': {
        title: 'About Us | MacGillis Global Academy',
        description:
            'Meet the experienced educators behind MacGillis Global Academy and learn about the mission, values, and accreditation behind our live online school.'
    },
    '/admissions': {
        title: 'Admissions & Tuition | MacGillis Global Academy',
        description:
            'How to apply to MacGillis Global Academy: admission requirements, tuition and fees, financial aid through FACTS Grant & Aid, and international student information.'
    },
    '/academics': {
        title: 'Academics & Curriculum | MacGillis Global Academy',
        description:
            'Explore the MacGillis Global Academy curriculum, weekly class schedule, and Interactive Wednesdays enrichment program for Lower and Upper School students.'
    },
    '/homeschool': {
        title: 'Homeschool Support Programs | MacGillis Global Academy',
        description:
            'Live online academic and enrichment classes that support homeschooling families, with experienced teachers and small group instruction.'
    },
    '/why-this-school': {
        title: 'Why Choose MGA | MacGillis Global Academy',
        description:
            'What sets MacGillis Global Academy apart: live synchronous instruction, small class sizes, and personalized attention in an accredited online school.'
    },
    '/open-house': {
        title: 'Virtual Open House Events | MacGillis Global Academy',
        description:
            'Join a live virtual open house to meet MacGillis Global Academy teachers, tour our online classrooms, and ask questions. Register for an upcoming date.'
    },
    '/admission-inquiry': {
        title: 'Admission Inquiry | MacGillis Global Academy',
        description:
            'Request more information about enrolling at MacGillis Global Academy. Tell us about your student and our admissions team will follow up.'
    },
    '/homework-support': {
        title: 'Homework Support | MacGillis Global Academy',
        description:
            'One-on-one and small group homework support from MacGillis Global Academy teachers, helping students build study skills and academic confidence.'
    },
    '/resources': {
        title: 'Family Resources | MacGillis Global Academy',
        description:
            'Flyers, forms, calendars, and reference materials for current and prospective MacGillis Global Academy families.'
    },
    '/404': {
        title: 'Page Not Found | MacGillis Global Academy',
        description: DEFAULT_SEO.description,
        noindex: true
    }
};

export const getSeoForPath = (pathname) => {
    // Tolerate trailing slashes so "/about/" and "/about" resolve alike.
    const normalized =
        pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    return seoByPath[normalized] || DEFAULT_SEO;
};

export default seoByPath;
